var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormulaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0C4.23981 0 0.773438 3.46637 0.773438 7.72656C0.773438 11.9868 4.23981 15.4531 8.5 15.4531C12.7602 15.4531 16.2266 11.9868 16.2266 7.72656C16.2266 3.46637 12.7602 0 8.5 0ZM8.5 14.0482C5.01466 14.0482 2.17835 11.2119 2.17835 7.72656C2.17835 4.2412 5.01463 1.40491 8.5 1.40491C11.9854 1.40491 14.8217 4.2412 14.8217 7.72656C14.8217 11.2119 11.9854 14.0482 8.5 14.0482Z",
    fill: "#097BED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.49924 5.61914C8.11154 5.61914 7.79688 5.93381 7.79688 6.32151V11.2382C7.79688 11.6259 8.11154 11.9406 8.49924 11.9406C8.88694 11.9406 9.20161 11.6259 9.20161 11.2382V6.32151C9.20161 5.93381 8.88694 5.61914 8.49924 5.61914Z",
    fill: "#097BED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20161 4.21408C9.20161 4.60202 8.88718 4.91657 8.49924 4.91657C8.1113 4.91657 7.79688 4.60202 7.79688 4.21408C7.79688 3.82615 8.1113 3.51172 8.49924 3.51172C8.88718 3.51172 9.20161 3.82615 9.20161 4.21408Z",
    fill: "#097BED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormulaIcon);
export default __webpack_public_path__ + "static/media/formula-icon.fd61a378b460510da7c896d3eee02cfc.svg";
export { ForwardRef as ReactComponent };